var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContactBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 1.4585H3.46672C2.54624 1.4585 1.80005 2.20469 1.80005 3.12516V16.7668C1.80005 17.6873 2.54624 18.4335 3.46672 18.4335H16.55C17.4705 18.4335 18.2167 17.6873 18.2167 16.7668V3.12516C18.2167 2.20469 17.4705 1.4585 16.55 1.4585Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02502 6.69189H17.8917",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70837 3.66699H3.83337V4.54199H4.70837V3.66699Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13342 3.66699H6.25842V4.54199H7.13342V3.66699Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6084 3.66699H8.7334V4.54199H9.6084V3.66699Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80005 6.69189H17.9917",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContactBrowser);
export default __webpack_public_path__ + "static/media/ic-contact-browser.c1daa7fcd2859f06379f4e7d01cd2a45.svg";
export { ForwardRef as ReactComponent };